<button [type]="type" [disabled]="!!disabled">
  <app-iconic *ngIf="!!icon" class="icon" [icon]="icon"></app-iconic>

  <ng-container *ngIf="!!text">
    {{ text }}
  </ng-container>
</button>

<div class="foreground"></div>
